var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useIntl } from "react-intl";
import { InputField, InputPasswordStrengthBar } from "peggirkit";
var SetPasswordField = function (_a) {
    var watch = _a.watch, register = _a.register, disabled = _a.disabled, fieldError = _a.fieldError, fieldName = _a.fieldName, displayName = _a.displayName;
    var intl = useIntl();
    return (_jsx(InputField, { id: fieldName, displayName: displayName, type: "password", placeholder: "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022", disabled: disabled, error: fieldError && fieldError.message, reactHookForm: __assign({}, register(fieldName, {
            required: intl.formatMessage({ id: "enterYourPassword" }),
            minLength: {
                value: 8,
                message: intl.formatMessage({ id: "mustContainAtLeastCharacters" }, { min: 8 })
            },
            maxLength: {
                value: 128,
                message: intl.formatMessage({ id: "canContainAtMostCharacters" }, { max: 128 })
            }
        })), after: _jsx(InputPasswordStrengthBar, { password: watch(fieldName), minLength: 8, scoreWords: {
                bad: intl.formatMessage({ id: "passwordStrength.weak" }),
                weak: intl.formatMessage({ id: "passwordStrength.weak" }),
                ok: intl.formatMessage({ id: "passwordStrength.ok" }),
                good: intl.formatMessage({ id: "passwordStrength.good" }),
                strong: intl.formatMessage({ id: "passwordStrength.strong" })
            }, shortScoreWord: intl.formatMessage({ id: "mustContainAtLeastCharacters" }, { min: 8 }) }) }));
};
export default SetPasswordField;
